import React from 'react';
import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import BannerSection from '../../components/BannerSection';
import SidebarMenu from '../../components/SidebarMenu'; 
import SectionHeading from '../../components/SectionHeading';
import BreadcrumbNav from '../../components/BreadcrumbNav';

const caminho = [
  { label: 'Home', href: '/', icon: 'bi bi-house-door' },
  { label: 'Área Científica' },
  { label: 'Investigação' },
];

function JornadaCientifica() {
    return (
        <>
        <header id='header'>
        <AppHeader />
        </header>
        <BannerSection
                title="Jornada Científica" 
                subtitle="Bem-vindo à Jornada Científica do ISP-Atlântida"
                description={`Participe da jornada científica do ISP-Atlântida, um evento anual que promove a pesquisa e o desenvolvimento científico na instituição. Conheça os trabalhos de pesquisa realizados por alunos e professores, além de palestras e debates sobre temas relevantes para a comunidade acadêmica.`}
                backgroundImage={require('../../assets/JorBanner.jpg')}
                backgroundId="instituition-Banner"
            />
            <BreadcrumbNav items={caminho} />
            <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
            <br />
            <div className="row flex-row-reverse">
                <div className="col-12 col-md-4 col-lg-3 col-xl-2">
                <SidebarMenu
                    title="Área Científica"
                    items={[
                    { label: "O que é Jornada Científica?", href: "/investigacao/jornada-cientifica" },
                    { label: "Submissão de Trabalhos", href: "/investigacao/submissao-resumo" },
                    { label: "Biblioteca virtual", href: "/investigacao/Biblioteca-virtual" },
                    ]}
                />
                </div>
                <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                <br />
                <div className="details-magazine" id='detalhes'>
                    <p className="f-reg">
                          <SectionHeading title="O que é Jornada Científica?" />
                    <br />
                    As Jornadas Científicas do ISP- Atlântida realizadas anualmente consistem num espaço de partilha de conhecimento e troca de experiências científicas entre investigadores, docentes, discentes e outros profissionais do sector público e privado. Por outro lado, propõe-se, igualmente, motivar a comunidade estudantil para o desenvolvimento de habilidades relativas à investigação científica. <br /><br />
                    Deste modo, as  Jornadas Científicas do ISPA que decorrerão no <b>dia  05 de Maio de 2026 no Polo Capalanga, no dia 07 e 08 de Maio de 2026</b> no ISPA-Cede incluirão um conjunto de actividades científicas, tais como, mesas redondas e palestras, sendo um fórum privilegiado de incentivo ao espírito crítico-reflexivo, criativo e investigativo das pessoas Trabalhadoras no Centro do Desenvolvimento Sustentavel.
                    <br /><br />
                    O tema desta 7ª edição das Jornadas Científicas do ISPA tem como lema <b>“Inovar hoje para garantir o trabalho de amanhã”</b> quer debater os diversos ângulos das estratégias e processos que podem incentivar o desenvolvimento sustentável das instituições, numa altura que se comemora o dia internacional dos trabalhadores.
                    <br /><br />
                    A participação no evento é aberta a toda a comunidade do ISPA, assim como à sociedade civil angolana e a todas as entidades que considerem o progresso científico fundamental para o desenvolvimento angolano <br /><br />
                    </p>
                    <br />
                </div>
                <br /><br />
                </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            </main>
        <AppLayout />
        </>
       
    );
}

export default JornadaCientifica;